module.exports = __webpack_public_path__ + "img/logo2x.97665768.png";